<template>
    <main class="my-leads">
		
		<section class="content-my-leads">
			<div class="content-my-leads-itens">
				<div class="content-my-leads-itens-bg">
					<div class="container">
						<div class="content-my-leads-itens-header">
							<div class="content-my-leads-itens-header-div">
								<router-link class="btn-return" to="/">
									<svg xmlns="http://www.w3.org/2000/svg" width="9.586" height="10.582" viewBox="0 0 9.586 10.582"><path d="M-3.006-7.547,4.33-4.582v2.3L-5.256-6.727V-8.437l9.586-4.43v2.3Z" transform="translate(5.256 12.867)"/></svg>
									<p>voltar</p>
								</router-link>
								<h1 class="title">
									As suas campanhas
								</h1>
							</div>
							<div class="content-my-leads-itens-header-element">
								<div class="content-text">
									<p>Concluídas <span>{{ total.concluded ? total.concluded : 0 }}</span></p>
								</div>
								<div class="div-border"></div>
								<div class="content-text">
									<p>Ativas <span>{{ total.opened ? total.opened : 0 }}</span></p>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div class="content-my-leads-itens-body">
					<div class="container">
						<div class="content-table">
							<table class="content-table-element">
								<tr>
									<th>Nome da campanha</th>
									<th>Leads Submetidos</th>
									<th>Data início e fim</th>
									<th>Estado</th>
									<th>Pontos Acumulados</th>
									<th>Posição</th>
								</tr>
								
								<template v-if="Object.keys(leads).length">
									<tr v-for="lead in leads.data" :key="lead.id">
										<td>
											<router-link 
												v-if="lead.campaign"
												:to="{name: 'campaign', params: {slug: lead.campaign.slug}}">
												{{lead.campaign.name}}</router-link>
											<span v-else>- campanha não encontrada -</span>
										</td>
										<td>{{lead.leads_count[0].count}}</td>
										<td>
											<template v-if="lead.campaign">
												{{lead.campaign.date_start_at|moment('DD/MM/YYYY')}}
												-
												{{lead.campaign.date_end_at|moment('DD/MM/YYYY')}}
											</template>
											<template v-else>
												---
											</template>
										</td>																				
										<td v-if="lead.campaign" class="aproved" 
											:style="{color: (lead.campaign.is_active ? 'green' : 'gray')}">
											{{lead.campaign.is_active ? 'A Decorrer' : 'Finalizada'}}</td>
										<td v-else>--</td>
										<td class="points">{{lead.balance}}</td>
										<td class="position">{{ lead.balance > 0 ? lead.rank : '---'}}º</td>
									</tr>
								</template>				
							</table>
							<!--  -->								
							<div v-if="Object.keys(leads).length && leads.last_page > 1" class="col-sm-12 mt-5" align="center">
								<nav aria-label="Page navigation example">
									<ul class="pagination">
										<li class="page-item">
											<a class="page-link"
											  :class="{
												  isDisabled: (!(leads.current_page > 1))
											  }"
											  @click="setPage(leads.current_page - 1)">Voltar</a>											  
										</li>

										<template v-for="page in leads.last_page">
											<li class="page-item" :key="page"
											:class="{active: (leads.current_page == page)}">
												<a class="page-link" @click="setPage(page)">{{page}}</a>
											</li>
										</template>										
										
										<li class="page-item">
											<a class="page-link"
											  :class="{
												  isDisabled: ((leads.current_page == leads.last_page))
											  }" 
											  @click="setPage(leads.current_page + 1)">Avançar</a>
										</li>
									</ul>
								</nav>
							</div>
							<!--  -->
						</div>						
					</div>
				</div>
			</div>
		</section>

	</main>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import axios from 'axios';

export default {
    data(){
        return{
            leads : {}, 
			total: {},
			page: 1,           
        }
    },    
    methods:{
        ...mapActions('App', ['loading']),
		async setPage(page){
			this.page = page;

			await this.getList();
		},
        async getList(){
            this.loading(true);
            await axios({
                method: 'GET',
                url: '/api/v1/campaign/my-campaigns',
                params: {
                   page: this.page
                }             
            }).then(response => response.data.data)
            .then((data) => {  
               this.loading(false); 				
               this.leads = data.leads;      
			   this.total = data.total;         
            })          
        },        
    },
    async mounted(){        		
        await this.getList();
    }
}
</script>